export default __webpack_public_path__ + "static/media/fka.bf69190a.svg";